'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab, TabList } from '@headlessui/react';
import type React from 'react';

/**
 * The dashboard's tabs, within a Headless UI TabGroup, in the pill style of the site's tabs
 * block. Every tab stays in view: on a narrow screen the row wraps rather than hiding tabs
 * behind a scroll. A tab can carry how much is still open behind it. The keyboard moves with
 * the arrow keys.
 */
export const DashboardTabList: React.FC<{
  tabs: {
    label: string;
    open?: number;
    openLabel?: string;
  }[];
  label: string;
}> = t0 => {
  const $ = _c(5);
  const {
    tabs,
    label
  } = t0;
  let t1;
  if ($[0] !== tabs) {
    t1 = tabs.map(_temp);
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <TabList aria-label={label} className="flex flex-wrap gap-1 rounded-3xl bg-gray-100 p-1 @3xl:inline-flex @3xl:rounded-full">{t1}</TabList>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(tab) {
  return <Tab key={tab.label} className="inline-flex min-h-10 grow cursor-pointer items-center justify-center gap-1.5 rounded-full px-4 text-sm font-medium whitespace-nowrap text-gray-500 outline-hidden transition-colors hover:text-gray-900 data-focus:ring-2 data-focus:ring-green-600 data-focus:ring-inset data-selected:bg-white data-selected:text-gray-900 data-selected:shadow-sm @3xl:grow-0 @3xl:px-5">{tab.label}{tab.open !== undefined && tab.open > 0 && <><span aria-hidden={true} className="bg-conveniat-green inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold text-white tabular-nums">{tab.open}</span><span className="sr-only">{tab.openLabel}</span></>}</Tab>;
}